export enum Errors {
  Error500 = 500,
  Error401 = 401,
  Error302 = 302,

  MS_TokenExpiration = 801,

  TokenExpired = 701,
  ForbiddenError = 703,
  InvalidRefresh = 805,
  RefreshRevoked = 806,
  RefreshExpired = 807,
  RefeshTokenDonstMatch = 808,
  InvalidAccessToken = 705,
  AccessTokenNotExpired = 704,
  ValidationError = 603,

  NotExistFiles = 904,
}
